import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 51210 44143"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:742.172}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528507497360">
        <path
          d="M19779 37810h11426v-4098H19779v4098zm11602 460H19602c-98 0-176-102-176-230v-4558c0-127 78-230 176-230h11779c97 0 177 103 177 230v4558c0 128-80 230-177 230zM4303 28346h42378V3724H4303v24622zm42544 333H4136c-92 0-167-75-167-166V3557c0-92 75-167 167-167h42711c92 0 167 75 167 167v24956c0 91-75 166-167 166zM41907 43419h8578v-1382c0-697-881-1294-1603-1294h-5372c-722 0-1603 597-1603 1294v1382zm8755 353h-8932c-98 0-177-79-177-177v-1558c0-434 233-852 654-1180 378-292 865-467 1303-467h5372c438 0 925 175 1303 467 421 328 654 747 654 1180v1558c0 98-80 177-177 177z"
          className="fill stroke1"
          style={{
            strokeWidth: 742.172,
          }}
        />
        <path
          d="M1095 725c-204 0-371 166-371 370v31786c0 204 167 371 371 371h48793c205 0 371-166 371-371V1095c0-204-166-370-371-370H1095zm48793 32881H1095c-399 0-724-326-724-725V1095c0-399 325-724 724-724h48793c399 0 724 325 724 724v31786c0 399-325 725-724 725zM46196 40636c-97 0-177-126-177-281 0-1628-831-2953-1854-2953h-4984c-1217 0-2207-1577-2207-3515 0-155 78-281 175-281 98 0 178 126 178 281 0 1627 831 2952 1854 2952l4984-1c1218 0 2207 1578 2207 3517 0 155-78 281-176 281z"
          className="fill stroke1"
          style={{
            strokeWidth: 742.172,
          }}
        />
        <path
          d="m33394 40757-2082-2487H19671l-2082 2487m-454 461c-72 0-138-59-165-147-25-89-8-189 46-253l2467-2948c32-38 75-60 119-60h11779c45 0 87 22 120 60l2453 2932c44 43 72 109 72 186 0 127-79 230-178 230"
          className="stroke1"
          style={{
            fill: "none",
            strokeWidth: 742.172,
          }}
        />
        <path
          d="M23962 31002c-169 0-306 137-306 307 0 168 137 306 306 306l3060-1c168 0 306-137 306-305 0-170-138-307-306-307h-3060zm3060 966h-3060c-364 0-659-296-659-659 0-364 295-660 659-660h3060c363 0 659 296 659 660 0 363-296 659-659 659z"
          className="fill stroke1"
          style={{
            strokeWidth: 742.172,
          }}
        />
        <rect
          width={18922}
          height={2128}
          x={15954}
          y={40370}
          rx={1587}
          ry={1484}
          style={{
            fill: "#1c1b17",
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
